// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".directorio .directorio_list>li .tarjeta_focus{background-color:#0090e4!important}.directorio .directorio_list>li .tarjeta_focus .firma_url{color:#0090e4!important}.directorio .directorio_list>li .tarjeta_focus .firma_buttons button{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
